<template>
  <v-form
    v-model="$storeUniversite.validInfoPerso"
    ref="formulaireInfoPerso"
    lazy-validation
  >
      <!-- Partie informations personnelles -->
       <v-expansion-panels multiple v-model="Panel.Principal">
        <v-expansion-panel ref="infosperso">
          <v-expansion-panel-header><h3>
            <!-- Label plus gros et souligné -->
            {{ $storeUniversite.label.InfoPerso }}
          </h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="$storeUniversite.inscription.Genre"
                  :items="$storeCatalogue.Genre"
                  :label="$storeUniversite.label.Genre"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  outlined
                  dense
                  :rules="[$rules.obligatoire()]"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  dense
                  :disabled="$storeUniversite.lectureSeule"
                  v-model="$storeUniversite.inscription.Prenom"
                  :label="$storeUniversite.label.Prenom"
                  outlined
                  :rules="[$rules.obligatoire(), $rules.latin()]"
                  class="asterisk"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  dense
                  :disabled="$storeUniversite.lectureSeule"
                  v-model="$storeUniversite.inscription.Nom"
                  :label="$storeUniversite.label.Nom"
                  outlined
                  :rules="[$rules.obligatoire(), $rules.latin()]"
                  class="asterisk"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              
              <v-col cols="12" md="4">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.PaysDeNaissance"
                  :items="$storeCatalogue.Pays"
                  :label="$storeUniversite.label.PaysNaissance"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  :rules="[$rules.obligatoire()]"
                  class="asterisk"
                  @change="PaysDeNaissanceChange"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.Nationalite2"
                  :items="$storeCatalogue.Pays"
                  :label="$storeUniversite.label.Nationalite2"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  :disabled="
                    $storeUniversite.lectureSeule ||
                    $storeUniversite.inscription.ReadOnly
                  "
                  dense
                  v-model="$storeUniversite.inscription.NumCniPasseport"
                  :label="
                    $storeUniversite.inscription.PaysDeResidence ===
                    this.$storeCatalogue.DataId.Maroc
                      ? $storeUniversite.label.CIN
                      : $storeUniversite.label.NumPassport
                  "
                  :rules="[$rules.cni()]"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      dense
                      v-model="$storeUniversite.inscription.DateDeNaissanceFormatee"
                      :label="$storeUniversite.label.DateDeNaissance"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      :disabled="$storeUniversite.inscription.ReadOnly"
                      :rules="[$rules.obligatoire(),$rules.EstDate(), $storeReglesBourse.AgeMinimumCandidat.ageMinimum]"
                      class="asterisk"
                      @change="SetDateNaissanceFormatee"
                    />
                  </template>
                  <v-date-picker
                    v-model="$storeUniversite.inscription.DateDeNaissance"
                    @input="menu = false"
                    :max="MaxDateNaissance"
                    :rules="[$rules.obligatoire()]"
                    :disabled="$storeUniversite.inscription.ReadOnly"
                    class="asterisk"
                    dense
                    @change="SetDateNaissanceDeformatee"
                  />
                </v-menu>
              </v-col>
              <v-col cols="12" md="4" v-if="$storeUniversite.inscription.PaysDeNaissance === $storeCatalogue.DataId.Maroc">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.VilleNaissance"
                  item-text="lang00"
                  item-value="lang00"
                  :items="$storeCatalogue.VilleMaroc"
                  :label="$storeUniversite.label.VilleNaissance"
                  @change="GestionPrecisionVille"
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" v-if="!$storeUniversite.inscription.VilleNaissance">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.PrecisionVilleNaissance"
                  :label="$storeUniversite.label.PrecisionVilleNaissance"
                  outlined
                  :rules="[$rules.obligatoire(), $rules.latin()]"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.EtrangerResidantAuMaroc"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.OuiNon"
                  :label="$storeUniversite.label.ResidentEtrangeMaroc"
                  outlined
                  :rules="[$rules.obligatoire()]"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.SituationDeHandicap"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.OuiNon"
                  :label="$storeUniversite.label.Handicap"
                  outlined
                  :rules="[$rules.obligatoire()]"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  @change="SituationDeHandicapChange"
                  class="asterisk"
                  :hint="$storeUniversite.inscription.SituationDeHandicap === $storeCatalogue.DataId.Oui
                    && !$storeUniversite.inscription.ReadOnly
                   ? $storeUniversite.label.JustifRequis : ''"
                  persistent-hint
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" v-if="$storeUniversite.inscription.SituationDeHandicap === $storeCatalogue.DataId.Oui">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.TypeDHandicap"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.NatureHandicap"
                  :label="$storeUniversite.label.NatureHandicap"
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  :readonly="$storeUniversite.inscription.ReadOnly"
                  multiple
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" v-if="false">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.EmployeEtatMarocain"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.OuiNon"
                  :label="$storeUniversite.label.EmployeEtatMarocain"
                  outlined
                  :rules="[$rules.obligatoire()]"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.DemandeBourseSociale"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.OuiNon"
                  :label="$storeUniversite.label.DemandeBourseSociale"
                  outlined
                  :rules="[$rules.obligatoire()]"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.StatutRefugie"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.OuiNon"
                  :label="$storeUniversite.label.StatutRefugie"
                  outlined
                  :rules="[$rules.obligatoire()]"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                  :hint="$storeUniversite.inscription.StatutRefugie === $storeCatalogue.DataId.Oui
                    && !$storeUniversite.inscription.ReadOnly
                   ? $storeUniversite.label.JustifRequis : ''"
                  persistent-hint
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel ref="sprotifHautNiveau">
          <v-expansion-panel-header>
            <h3>
              <!-- Label plus gros et souligné -->
              {{ $storeUniversite.label.SportifHautNiveau }}
            </h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.SportifHautNiveau"
                  :label="$storeUniversite.label.EtesVousSportifHautNiveau"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.OuiNon"
                  outlined
                  @change="GestionDisciplineSportive"
                  :rules="[$rules.obligatoire()]"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                  :hint="$storeUniversite.inscription.SportifHautNiveau === $storeCatalogue.DataId.Oui
                    && !$storeUniversite.inscription.ReadOnly
                   ? $storeUniversite.label.JustifRequis : ''"
                  persistent-hint
                ></v-autocomplete>
              </v-col>
               <v-col cols="12" md="4" v-if="$storeUniversite.inscription.SportifHautNiveau === $storeCatalogue.DataId.Oui">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.Disciplines"
                  :label="$storeUniversite.label.Discipline"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.DisciplineSportive"
                  outlined
                  :rules="[$rules.obligatoire()]"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  :readonly="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                  multiple
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel ref="infospostales">
          <v-expansion-panel-header>
            <h3>
              <!-- Label plus gros et souligné -->
              {{ $storeUniversite.label.InformationPostal }}
            </h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.PaysDeResidence"
                  :label="$storeUniversite.label.PaysResidence"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.Pays"
                  outlined
                  :rules="[$rules.obligatoire()]"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.Tel"
                  :label="$storeUniversite.label.Telephone"
                  :rules="[$rules.obligatoire(), $rules.telephone()]"
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="$storeUniversite.inscription.PaysDeResidence === $storeCatalogue.DataId.Maroc">
              <v-col cols="12" md="12">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.AdresseAuMaroc"
                  :label="$storeUniversite.label.Addresse"
                  outlined
                  :rules="[$rules.obligatoire(), $rules.Adresse()]"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="$storeUniversite.inscription.PaysDeResidence === $storeCatalogue.DataId.Maroc">
              <v-col cols="12" md="12">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.Adresse2"
                  :label="$storeUniversite.label.Addresse2"
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  :rules="[$rules.Adresse()]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="$storeUniversite.inscription.PaysDeResidence === $storeCatalogue.DataId.Maroc">
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.CodePostal"
                  :label="$storeUniversite.label.CodePostal"
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  :rules="[$rules.LengthDix()]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.VilleMaroc"
                  :label="$storeUniversite.label.Ville"
                  outlined
                  :rules="[$rules.obligatoire(), $rules.latin()]"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="$storeUniversite.inscription.PaysDeResidence === $storeCatalogue.DataId.Maroc">
              <v-col cols="12" md="6">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.ProvinceMA"
                  :label="$storeUniversite.label.District"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.Province"
                  :rules="[$rules.obligatoire()]"
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.RegionMA"
                  :label="$storeUniversite.label.Region"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.Region"
                  outlined
                  :rules="$storeUniversite.inscription.PaysDeResidence ===
                    $storeCatalogue.DataId.Maroc
                      ? [$rules.obligatoire()]
                      : []"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  :class="{ asterisk: $storeUniversite.inscription.PaysDeResidence === $storeCatalogue.DataId.Maroc }"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="$storeUniversite.inscription.PaysDeResidence !== $storeCatalogue.DataId.Maroc">
              <v-col cols="12" md="12">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.AutreAdresse"
                  :label="$storeUniversite.label.Addresse"
                  :rules="
                    $storeUniversite.inscription.PaysDeResidence !==
                    $storeCatalogue.DataId.Maroc
                      ? [$rules.obligatoire(), $rules.Adresse()]
                      : [$rules.Adresse()]"
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  :class="{ asterisk: $storeUniversite.inscription.PaysDeResidence !== $storeCatalogue.DataId.Maroc }"
                ></v-text-field>
              </v-col>
            </v-row>  
            <v-row v-if="$storeUniversite.inscription.PaysDeResidence !== $storeCatalogue.DataId.Maroc">
              <v-col cols="12" md="12">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.AutreAdresse2"
                  :label="$storeUniversite.label.Addresse2"
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  :rules="[$rules.Adresse()]"
                ></v-text-field>
              </v-col>
            </v-row>  
            <v-row v-if="$storeUniversite.inscription.PaysDeResidence !== $storeCatalogue.DataId.Maroc">
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.AutreVille"
                  :label="$storeUniversite.label.Ville"
                  outlined
                  :rules="$storeUniversite.inscription.PaysDeResidence !==
                    $storeCatalogue.DataId.Maroc
                      ? [$rules.obligatoire(), $rules.latin()]
                      : [$rules.latin()]"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  :class="{ asterisk: $storeUniversite.inscription.PaysDeResidence !== $storeCatalogue.DataId.Maroc }"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.AutreCodePostal"
                  :label="$storeUniversite.label.CodePostal"
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  :rules="[$rules.obligatoire(), $rules.LengthDix()]"
                  class="asterisk"
                ></v-text-field>
              </v-col>
            </v-row>  
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel ref="infostuteur" v-if="false">
          <v-expansion-panel-header>
            <h3> {{ $storeUniversite.label.InfoTuteur }} </h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.InfosTuteur.Genre"
                  :items="$storeCatalogue.Genre"
                  label="Genre tuteur"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  outlined
                  :rules="[$rules.obligatoire()]"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  dense
                  v-model="
                    $storeUniversite.inscription.InfosTuteur.NatureDeLaRelation
                  "
                  :items="$storeCatalogue.RelationTuteur"
                  :label="$storeUniversite.label.RelationCandidatTuteur"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  :rules="[$rules.obligatoire()]"
                  class="asterisk"
                ></v-autocomplete>
              </v-col>
              </v-row>
              <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.InfosTuteur.Prenom"
                  :label="$storeUniversite.label.Prenom"
                  outlined
                  :rules="[$rules.obligatoire(), $rules.latin()]"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.InfosTuteur.Nom"
                  :label="$storeUniversite.label.Nom"
                  outlined
                  :rules="[$rules.obligatoire(), $rules.latin()]"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.InfosTuteur.Tel"
                  :label="$storeUniversite.label.Telephone"
                  outlined
                  :rules="[$rules.obligatoire(), $rules.telephone()]"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.InfosTuteur.Email"
                  :label="$storeUniversite.label.Email"
                  :rules="[$rules.email()]"
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.InfosTuteur.Profession"
                  :label="$storeUniversite.label.Profession"
                  outlined
                  :rules="[$rules.obligatoire(), $rules.latin()]"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel ref="adressetuteur" v-if="false">
          <v-expansion-panel-header>
            <h3> {{ $storeUniversite.label.AddressTuteur }} </h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-col cols="12" md="5">
                <v-autocomplete
                  dense
                  v-model="
                    $storeUniversite.inscription.InfosTuteur.MemeAdresseQueLeCandidat
                  "
                  :items="$storeCatalogue.OuiNon"
                  :label="$storeUniversite.label.MemeAddressTuteur"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  outlined
                  @change="GetTutorAdr"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  :rules="[$rules.obligatoire()]"
                  class="asterisk"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="$storeUniversite.inscription.InfosTuteur.MemeAdresseQueLeCandidat ===$storeCatalogue.DataId.Non">
              <v-col cols="12" md="12">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.InfosTuteur.Adresse1"
                  :label="$storeUniversite.label.Addresse"
                  :rules="
                    $storeUniversite.inscription.InfosTuteur
                      .MemeAdresseQueLeCandidat === $storeCatalogue.DataId.Non
                      ? [$rules.obligatoire(), $rules.Adresse()]
                      : [$rules.Adresse()]
                  "
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  :class="{ asterisk: $storeUniversite.inscription.InfosTuteur.MemeAdresseQueLeCandidat === $storeCatalogue.DataId.Non }"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.InfosTuteur.Adresse2"
                  :label="$storeUniversite.label.Addresse2"
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  :rules="[$rules.Adresse()]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="$storeUniversite.inscription.InfosTuteur.MemeAdresseQueLeCandidat ===$storeCatalogue.DataId.Non">
              <v-col cols="12" md="6">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.InfosTuteur.Pays"
                  :label="$storeUniversite.label.Pays"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.Pays"
                  outlined
                  :rules="
                    $storeUniversite.inscription.InfosTuteur
                      .MemeAdresseQueLeCandidat === $storeCatalogue.DataId.Non
                      ? [$rules.obligatoire()]
                      : []
                  "
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  :class="{ asterisk: $storeUniversite.inscription.InfosTuteur.MemeAdresseQueLeCandidat === $storeCatalogue.DataId.Non }"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row 
            v-if="$storeUniversite.inscription.InfosTuteur.MemeAdresseQueLeCandidat === $storeCatalogue.DataId.Non
            && $storeUniversite.inscription.InfosTuteur.Pays === $storeCatalogue.DataId.Maroc">
              <v-col cols="12" md="6">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.InfosTuteur.Region"
                  :label="$storeUniversite.label.Region"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.Region"
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.InfosTuteur.ProvinceMaroc"
                  :label="$storeUniversite.label.District"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.Province"
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="$storeUniversite.inscription.InfosTuteur.MemeAdresseQueLeCandidat ===$storeCatalogue.DataId.Non">
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.InfosTuteur.Ville"
                  :label="$storeUniversite.label.Ville"
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.InfosTuteur.CodePostal"
                  :label="$storeUniversite.label.CodePostal"
                  outlined
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  :rules="[$rules.LengthDix()]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
       </v-expansion-panels>
      <br />
      <v-row>
        <span class="required">
          <span class="legend"></span>
        </span>
      </v-row>
      <br />
  </v-form>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      Panel:{
        Principal:[0,1,2,3]
      },
      showDatePicker: false,
      menu: false,
      //réafecter l'objet global
      $storeUniversite: this.$storeUniversite,
      $storeCatalogue: this.$storeCatalogue,
    };
  },
  mounted() {
    this.$refs.formulaireInfoPerso.resetValidation();
  },
  computed: {
    MaxDateNaissance() {
      return moment(String(new Date()))
        .subtract(13, "year")
        .format("YYYY-MM-DD");
    },
  },
  methods: {
    SituationDeHandicapChange(){
      this.$storeUniversite.inscription.TypeDHandicap = [];
    },
    PaysDeNaissanceChange(){
      this.$storeUniversite.inscription.VilleNaissance = null;
      this.$storeUniversite.inscription.PrecisionVilleNaissance = null;
      this.$refs.formulaireInfoPerso.resetValidation();
    },
    SetDateNaissanceFormatee(){
      this.$storeUniversite.inscription.DateDeNaissance = this.$storeUniversite.UnFormatDate(this.$storeUniversite.inscription.DateDeNaissanceFormatee);
    },
    SetDateNaissanceDeformatee(){
      this.$storeUniversite.inscription.DateDeNaissanceFormatee = this.$storeUniversite.FormatDate(this.$storeUniversite.inscription.DateDeNaissance);
    },
    Valider() {
      return this.$refs.formulaireInfoPerso.validate();
    },
    GestionDisciplineSportive() {
      if (
        this.$storeUniversite.inscription.SportifHautNiveau ==
        this.$storeCatalogue.DataId.Non
      ) {
        this.$storeUniversite.inscription.Disciplines = [];
        this.$emit("update:LoadingList", true);
      }
    },
    GestionPrecisionVille()
    {
      this.$storeUniversite.inscription.PrecisionVilleNaissance = null;
    },
    GetTutorAdr() {
      if (
        this.$storeUniversite.inscription.PaysDeResidence ===
        this.$storeCatalogue.DataId.Maroc
      ) {
        if (
          this.$storeUniversite.inscription.InfosTuteur
            .MemeAdresseQueLeCandidat === this.$storeCatalogue.DataId.Oui
        ) {
          this.$storeUniversite.inscription.InfosTuteur.Adresse1 =
            this.$storeUniversite.inscription.AdresseAuMaroc;
          this.$storeUniversite.inscription.InfosTuteur.Adresse2 =
            this.$storeUniversite.inscription.Adresse2;
          this.$storeUniversite.inscription.InfosTuteur.Pays =
            this.$storeUniversite.inscription.PaysDeResidence;
          this.$storeUniversite.inscription.InfosTuteur.Region =
            this.$storeUniversite.inscription.Region;
          this.$storeUniversite.inscription.InfosTuteur.Ville =
            this.$storeUniversite.inscription.VilleMaroc;
          this.$storeUniversite.inscription.InfosTuteur.CodePostal =
            this.$storeUniversite.inscription.CodePostal;
          this.$storeUniversite.inscription.InfosTuteur.RegionMA =
            this.$storeUniversite.inscription.Region;
        } else {
          this.$storeUniversite.inscription.InfosTuteur.Adresse1 = null;
          this.$storeUniversite.inscription.InfosTuteur.Adresse2 = null;
          this.$storeUniversite.inscription.InfosTuteur.Pays = null;
          this.$storeUniversite.inscription.InfosTuteur.Region = null;
          this.$storeUniversite.inscription.InfosTuteur.Ville = null;
          this.$storeUniversite.inscription.InfosTuteur.CodePostal = null;
        }
      } else {
        if (
          this.$storeUniversite.inscription.InfosTuteur
            .MemeAdresseQueLeCandidat === this.$storeCatalogue.DataId.Oui
        ) {
          this.$storeUniversite.inscription.InfosTuteur.Adresse1 =
            this.$storeUniversite.inscription.AdresseAuMaroc;
          this.$storeUniversite.inscription.InfosTuteur.Adresse2 =
            this.$storeUniversite.inscription.Adresse2;
          this.$storeUniversite.inscription.InfosTuteur.Pays =
            this.$storeUniversite.inscription.PaysDeResidence;
          this.$storeUniversite.inscription.InfosTuteur.Ville =
            this.$storeUniversite.inscription.Ville;
          this.$storeUniversite.inscription.InfosTuteur.CodePostal =
            this.$storeUniversite.inscription.CodePostal;
        } else {
          this.$storeUniversite.inscription.InfosTuteur.Adresse1 = null;
          this.$storeUniversite.inscription.InfosTuteur.Adresse2 = null;
          this.$storeUniversite.inscription.InfosTuteur.Pays = null;
          this.$storeUniversite.inscription.InfosTuteur.RegionMA = null;
          this.$storeUniversite.inscription.InfosTuteur.Ville = null;
          this.$storeUniversite.inscription.InfosTuteur.CodePostal = null;
        }
      }
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/InscriptionUniversite.css";
</style>
